import { render, staticRenderFns } from "./AdminSignupPages.vue?vue&type=template&id=15ac1679"
import script from "./AdminSignupPages.vue?vue&type=script&lang=js"
export * from "./AdminSignupPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports